export const navigateToSection = ({ sectionId, pathname, navigate, setActiveSection }) => {
  setActiveSection?.(sectionId);

  if (pathname !== "/") {
    navigate(sectionId === "home" ? "/" : `/#${sectionId}`);
    return;
  }

  if (sectionId === "home") {
    window.history.replaceState({}, "", "/");
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  const element = document.getElementById(sectionId);

  if (element) {
    window.history.replaceState({}, "", `/#${sectionId}`);
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
